import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  public isSpinningStream$ = new BehaviorSubject<boolean>(false);

  // Driven by router navigation (see AppComponent). Kept separate from the
  // HTTP-interceptor stream above so the two never clobber each other's state.
  // This is what gives feedback during route resolvers whose GraphQL requests
  // bypass the HTTP-interceptor spinner.
  public isNavigatingStream$ = new BehaviorSubject<boolean>(false);

  public showSpinner(): void {
    this.isSpinningStream$.next(true);
  }

  public hideSpinner(): void {
    this.isSpinningStream$.next(false);
  }

  public showNavigationSpinner(): void {
    this.isNavigatingStream$.next(true);
  }

  public hideNavigationSpinner(): void {
    this.isNavigatingStream$.next(false);
  }
}
